/**
 * Angular 2 decorators and services
 */
import {
  Component,
  OnInit,
  ViewEncapsulation
}                           from '@angular/core';
import { SwUpdate }         from '@angular/service-worker';

import {
  CtmMessageService,
  CtmTranslateService,
  MESSAGE_DIALOG_TYPE
}                           from "./_common";

import {
  CtmConstantService
}                           from "./_custom";


import { AppState }         from './app.service';

/**
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  template: require('./app.component.html')
})
export class AppComponent {
  constructor(
    private appState: AppState,
    private translate: CtmTranslateService,
    private constant: CtmConstantService,
    private message: CtmMessageService,
    private swUpdate: SwUpdate
  ) {
    Promise.all([
      this.translate.initialResource(),
      this.constant.initialConstant()
    ]).then(() => {
        $(".app-loading").fadeOut(500);
      });
  }

  ngAfterViewInit() {
    if (this.swUpdate != undefined) {
      if (this.swUpdate.isEnabled != true) {
        console.log("Software not enabled.");
      }
      else {
        this.swUpdate.available.subscribe((event) => {
          console.log("Has new version.");

          this.message.openMessageDialog("Has new version of website, please reload website.", MESSAGE_DIALOG_TYPE.INFORMATION)
            .then(() => {
              this.swUpdate.activateUpdate()
              .then(() => {
                document.location.reload();
              });
            });
        });

        console.log("Begin check website is update?");
        this.swUpdate.checkForUpdate();
      }
    }
    else {
      console.log("Software update not found.");
    }
  }
}

/**
 * Please review the https://github.com/AngularClass/angular2-examples/ repo for
 * more angular app examples that you may copy/paste
 * (The examples may not be updated as quickly. Please open an issue on github for us to update it)
 * For help or questions please contact us at @AngularClass on twitter
 * or our chat on Slack at https://AngularClass.com/slack-join
 */



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.component.ts